import { memo } from 'react';
import { CreateJobPostAfterSubmitModal, CreateJobPostAddQuestionModal } from 'view/modals';
import { useGetJobPostById } from 'view/pages/createJobPost/hooks/useGetJobPostById';

export const CreateJobPostConfigContainer = memo(() => {
  useGetJobPostById();
  return (
    <>
      <CreateJobPostAfterSubmitModal hideCloseButton />
      <CreateJobPostAddQuestionModal />
    </>
  );
});
